import React, { useMemo } from 'react'
import { DetailCard } from '@tecuity/granite-ui/DetailCard'
import { DetailList } from '@tecuity/granite-ui/DetailList'

const MiscGenericDetails = ({ cards, recordData, moduleName }) => {
  const fieldValueMap = useMemo(
    () =>
      (recordData?.Fields || []).reduce((acc, f) => {
        acc[f.DbFieldName] = f.Value
        return acc
      }, {}),
    [recordData]
  )

  const sortedCards = useMemo(() => {
    if (!cards || cards.length === 0) return []
    return cards.slice().sort((a, b) => a.SortOrder - b.SortOrder).map((card) => ({
      ...card,
      details: card.Fields.filter((f) => f.IsEnabled).map((f) => ({
        label: f.Label || f.DbFieldName,
        value: fieldValueMap[f.DbFieldName] ?? '',
      })),
    }))
  }, [cards, fieldValueMap])

  if (!cards || cards.length === 0) {
    return <p>Record Detail Configuration not set for &apos;{moduleName}&apos;</p>
  }

  return (
    <div
      className="row"
      style={{ display: 'flex', flexDirection: 'row', gap: '20px', marginBottom: '20px' }}
    >
      {sortedCards.map((card) => (
        <DetailCard key={card.CardId} label={card.Label} className="detailsCard">
          <DetailList details={card.details} />
        </DetailCard>
      ))}
    </div>
  )
}

export default MiscGenericDetails
